import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

import runtimeConfig from "../runtimeConfig";

interface Props {
  children: React.ReactElement;
}

/**
 * Inject Auth0Provider if partner authentication is provided by legalvisio
 */
const AuthProvider: React.FC<Props> = ({ children }) => {
  const partnerAuth = runtimeConfig.partnerAuth;

  return (
    <>
      {partnerAuth === "LV" ? (
        <Auth0Provider
          domain={runtimeConfig.authDomain}
          clientId={runtimeConfig.authAudience}
          redirectUri={window.location.origin}
        >
          {children}
        </Auth0Provider>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default AuthProvider;
